<template>
    <v-card>
        <v-card-title>
            <v-spacer />
            <v-btn small icon class="mr-2" @click="$emit('close')">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-card-title>

        <v-card-text class="pt-0">
            <div v-if="typeError === 'validation_excel'" class="text-center">
                <div
                    class="font-weight-bold black--text mb-1"
                    style="font-size: 18px"
                >
                    {{ liveClassTotalErrorExcel || 0 }} dari
                    {{ liveClassData.length || 0 }}
                    Data Live Class Bermasalah
                </div>

                <div>
                    Kami menemukan eror pada berkas live class data Anda.
                    Silahkan perbaiki sesuai detail kesalahan yang tertera.
                </div>
            </div>

            <div v-if="typeError === 'upload_excel'" class="text-center">
                <div align="center" class="mb-5">
                    <v-img
                        :src="require('@/assets/img/failed.svg')"
                        height="90"
                        width="90"
                    />
                </div>

                <div
                    class="font-weight-bold black--text mb-1"
                    style="font-size: 18px"
                >
                    Gagal Memproses {{ liveClassTotalErrorExcel || 0 }} Data
                </div>

                <div>
                    Kami menemukan eror pada berkas live class data Anda.
                    Silahkan perbaiki sesuai detail kesalahan yang tertera.
                </div>
            </div>

            <v-card class="mt-7" outlined>
                <v-card-text class="px-0">
                    <div
                        class="font-weight-bold px-2 pb-4 black--text d-flex align-center"
                    >
                        <div>
                            <v-img
                                :src="require('@/assets/img/list_failed.svg')"
                                contain
                                height="35"
                                class="mr-1"
                            ></v-img>
                        </div>

                        {{ liveClassTotalErrorExcel }} data live class gagal
                        diproses
                    </div>

                    <v-divider />

                    <v-simple-table fixed-header height="285px">
                        <thead>
                            <tr>
                                <th>Baris</th>
                                <th width="40%">Nama</th>
                                <th>Status</th>
                                <th width="35%">Detail Kesalahan</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="data in liveClassExcelError">
                                <td>{{ data.baris }}</td>
                                <td>
                                    {{
                                        data.judul_live_class ||
                                        "Tidak ada judul"
                                    }}
                                </td>
                                <td>
                                    <v-btn
                                        rounded
                                        small
                                        depressed
                                        color="#f7d5d5"
                                        class="error--text"
                                    >
                                        Gagal
                                    </v-btn>
                                </td>
                                <td v-html="data.error" class="py-3"></td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card-text>
            </v-card>
        </v-card-text>

        <v-card-actions>
            <v-spacer />
            <v-btn
                v-if="typeError === 'upload_excel'"
                color="blew"
                depressed
                dark
                :loading="loadingExport"
                @click="exportToExcel()"
            >
                Download File
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { read, utils, writeFile } from "xlsx";

export default {
    props: {
        liveClassTotalErrorExcel: { type: Number, default: 0 },
        liveClassExcelError: { type: Object, default: [] },
        liveClassData: { type: Object, default: [] },
        typeError: { type: String, default: null },
    },
    name: "DialogExcelErrorUpload",
    data: function () {
        return {
            loadingExport: false,
        };
    },
    methods: {
        exportToExcel() {
            try {
                this.loadingExport = true;

                const data = this.liveClassExcelError.map((item) => ({
                    judul_live_class: item.judul_live_class,
                    deskripsi: item.deskripsi,
                    mata_pelajaran_id: item.mata_pelajaran_id,
                    teacher_id: item.teacher_id,
                    teacher_detail: item.teacher_detail,
                    youtube_url: item.youtube_url,
                    roomPassword: item.roomPassword,
                    jenjang: item.jenjang,
                    tipe: item.tipe,
                    rombel_id: item.rombel_id,
                    kelas: item.kelas,
                    tanggal: item.tanggal,
                    waktu_mulai: item.waktu_mulai,
                    waktu_berakhir: item.waktu_berakhir,
                    user_group: item.user_group,
                    thumbnail_url: item.thumbnail_url,
                    is_private: item.is_private,
                    is_potrait: item.is_potrait,
                }));

                const ws = utils.json_to_sheet(data);
                const num_cols = 19;
                ws["!cols"] = Array.from({ length: num_cols }, () => ({
                    wch: 25,
                }));

                const wb = utils.book_new();
                utils.book_append_sheet(wb, ws, "Live Class List");
                writeFile(wb, "LiveClassErrors.xlsx");
            } finally {
                sessionStorage.removeItem("error_upload_liveclass");
                this.loadingExport = false;
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// DialogExcelErrorUpload.vue?4f826edc